module.exports = __webpack_public_path__ + "img/imgCenter.e90be7ea.gif";